/**
 * @enum {String}
 * @type {{NEW: string, APPROVE: string, REJECT: string, FOLLOW_UP: string, 
 *         FOLLOW_UP_1: string, FOLLOW_UP_2: string, FOLLOW_UP_3: string, FOLLOW_UP_4: string,
 *         APPROVE_FOLLOW_UP: string, REGISTER: string, TOP_UP: string, TOP_UP_1: string,
 *           TOP_UP_2: string, TOP_UP_3: string, TOP_UP_4: string}}
 */
 export const AGENT_FLAG = {
    NEW: "ADMIN",
    APPROVE: "APPROVE",
    REJECT: "REJECT",
    FOLLOW_UP: "FOLLOW UP",
    FOLLOW_UP_1: "FOLLOW UP 1",
    FOLLOW_UP_2: "FOLLOW UP 2",
    FOLLOW_UP_3: "FOLLOW UP 3",
    FOLLOW_UP_4: "FOLLOW UP 4",
    APPROVE_FOLLOW_UP: "APPROVE FOLLOW UP",
    REGISTER: "REGISTER",
    TOP_UP: "TOP UP",
    TOP_UP_1: "TOP UP 1",
    TOP_UP_2: "TOP UP 2",
    TOP_UP_3: "TOP UP 3",
    TOP_UP_4: "TOP UP 4", 
}

/**
 * @enum {String}
 * @type {{YES: string, NO: string}}
 */
export const BOOLEAN_STRING = {
    YES: "YES",
    NO: "NO",
}
